











import { computed, defineComponent } from '@vue/composition-api'
import useReferral from '@/composables/use-referral'
import useBreakpoint from '@/composables/use-breakpoint'

export default defineComponent({
  props: {
    confirmLink: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    const { match } = useBreakpoint()
    const isMobile = !match('lg')
    const { copied, getTrackUrl, copyCurrentUrl, nativeShare } = useReferral()

    const shareUrl = computed(() => {
      if (props.confirmLink.startsWith('http')) {
        return props.confirmLink
      }
      return window.location.origin + props.confirmLink
    })

    const handleClick = () => {
      if (isMobile) {
        nativeShare({
          url: getTrackUrl(shareUrl.value),
        })
      } else {
        copyCurrentUrl(shareUrl.value)
      }
    }

    return {
      copied,
      handleClick,
      shareUrl,
    }
  },
})
